export default __webpack_public_path__ + "static/media/cyborcoindark.5a31827e.svg";